import cx from 'classnames';
import { Text, Icon, Link } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface IFormError {
  message?: string;
  to?: string;
  linkText?: string;
  className?: string;
  reload?: boolean;
}

export const FormError = ({ message, to, linkText, className, reload = false }: IFormError) => {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className={cx(s.container, s.containerError, className)}>
      <Icon icon={Icon.icons.warning} color="error" />
      <Text className={s.containerMessage} color={Text.color.error}>
        {message}
      </Text>
      {to && linkText && (
        <Link to={to} className={s.containerMessageLink}>
          {linkText}
        </Link>
      )}
      {reload && (
        <button type="button" className={s.containerMessageLink} onClick={reloadPage}>
          Reload page.
        </button>
      )}
    </div>
  );
};
